if ((window.location == window.parent.location)) {
  const urlParams = new URLSearchParams(window.location.search);
  const refParam = urlParams.get('alan');
  if (!refParam) {
    $.get("https://ipinfo.io/json", function (response) {
      switch(response.country) {
        case 'AT':
        case 'BE':
        case 'BG':
        case 'HR':
        case 'CZ':
        case 'DK':
        case 'FO':
        case 'GL':
        case 'DE':
        case 'EE':
        case 'FI':
        case 'GF':
        case 'PF':
        case 'TF':
        case 'GP':
        case 'MQ':
        case 'YT':
        case 'NC':
        case 'RE':
        case 'BL':
        case 'MF':
        case 'PM':
        case 'WF':
        case 'FR':
        case 'GR':
        case 'HU':
        case 'IS':
        case 'IT':
        case 'IE':
        case 'LV':
        case 'LT':
        case 'LU':
        case 'MK':
        case 'NO':
        case 'NL':
        case 'AW':
        case 'BQ':
        case 'CW':
        case 'SX':
        case 'PL':
        case 'PT':
        case 'RO':
        case 'SK':
        case 'SI':
        case 'SE':
        case 'CH':
        case 'ES':
        case 'TR':
        case 'AX':
        case 'BV':
        case 'SJ':
          if (window.location.href.indexOf('tantaly.de/') < 0) {
              window.location.href = 'https://www.tantaly.de/';  
          }
          break
        // case 'JP':
        //   if (window.location.href.indexOf('tantaly.jp/') < 0) {
        //       window.location.href = 'https://tantaly.jp/?sca_ref=811.Jrui57DRF';  
        //   }
        //   break
        case 'CA':
          if (window.location.href.indexOf('tantaly.ca/') < 0) {
              window.location.href = 'https://www.tantaly.ca/';  
          }
          break
        case 'AF':
        case 'AL':
        case 'DZ':
        case 'AS':
        case 'AD':
        case 'AO':
        case 'AQ':
        case 'AG':
        case 'AR':
        case 'AM':
        case 'AU':
        case 'AZ':
        case 'BS':
        case 'BH':
        case 'BD':
        case 'BB':
        case 'BY':
        case 'BZ':
        case 'BJ':
        case 'BT':
        case 'BO':
        case 'BQ':
        case 'BA':
        case 'BW':
        case 'BR':
        case 'BN':
        case 'BF':
        case 'BI':
        case 'CV':
        case 'KH':
        case 'CM':
        case 'CF':
        case 'TD':
        case 'CL':
        case 'CN':
        case 'CX':
        case 'CC':
        case 'CO':
        case 'KM':
        case 'CD':
        case 'CG':
        case 'CK':
        case 'CR':
        case 'CI':
        case 'CU':
        case 'CY':
        case 'DJ':
        case 'DM':
        case 'DO':
        case 'EC':
        case 'EG':
        case 'SV':
        case 'GQ':
        case 'ER':
        case 'SZ':
        case 'ET':
        case 'FJ':
        case 'GA':
        case 'GM':
        case 'GE':
        case 'GH':
        case 'GD':
        case 'GU':
        case 'GT':
        case 'GN':
        case 'GW':
        case 'GY':
        case 'HT':
        case 'HM':
        case 'VA':
        case 'HN':
        // case 'HK':
        case 'IN':
        case 'ID':
        case 'IR':
        case 'IQ':
        case 'IL':
        case 'JM':
        case 'JP':
        case 'JO':
        case 'KZ':
        case 'KE':
        case 'KI':
        case 'KP':
        case 'KR':
        case 'KW':
        case 'KG':
        case 'LA':
        case 'LB':
        case 'LS':
        case 'LR':
        case 'LY':
        case 'LI':
        case 'MO':
        case 'MG':
        case 'MW':
        case 'MY':
        case 'MV':
        case 'ML':
        case 'MT':
        case 'MH':
        case 'MR':
        case 'MU':
        case 'MX':
        case 'FM':
        case 'MD':
        case 'MC':
        case 'MN':
        case 'ME':
        case 'MA':
        case 'MZ':
        case 'MM':
        case 'NA':
        case 'NR':
        case 'NP':
        case 'NZ':
        case 'NI':
        case 'NE':
        case 'NG':
        case 'NU':
        case 'NF':
        case 'MP':
        case 'OM':
        case 'PK':
        case 'PW':
        case 'PS':
        case 'PA':
        case 'PG':
        case 'PY':
        case 'PE':
        case 'PH':
        case 'PR':
        case 'QA':
        case 'RU':
        case 'RW':
        case 'KN':
        case 'LC':
        case 'VC':
        case 'WS':
        case 'SM':
        case 'ST':
        case 'SA':
        case 'SN':
        case 'RS':
        case 'SC':
        case 'SL':
        case 'SG':
        case 'SB':
        case 'SO':
        case 'ZA':
        case 'SS':
        case 'LK':
        case 'SD':
        case 'SR':
        case 'SY':
        case 'TW':
        case 'TJ':
        case 'TZ':
        case 'TH':
        case 'TL':
        case 'TG':
        case 'TK':
        case 'TO':
        case 'TT':
        case 'TN':
        case 'TM':
        case 'TV':
        case 'UG':
        case 'UA':
        case 'AE':
        case 'UM':
        case 'US':
        case 'UY':
        case 'UZ':
        case 'VU':
        case 'VE':
        case 'VN':
        case 'VI':
        case 'EH':
        case 'YE':
        case 'ZM':
        case 'ZW':
          if (window.location.href.indexOf('tantaly.com/') < 0) {
              window.location.href = 'https://www.tantaly.com/';  
          }
          break
        case 'AI':
        case 'BM':
        case 'IO':
        case 'KY':
        case 'FK':
        case 'GI':
        case 'MS':
        case 'PN':
        case 'SH':
        case 'GS':
        case 'TC':
        case 'VG':
        case 'GG':
        case 'IM':
        case 'JE':
        case 'GB':
        case 'UK':
          if (window.location.href.indexOf('tantaly.co.uk/') < 0) {
              window.location.href = 'https://tantaly.co.uk/';  
          }
          break
        default:
          break
      }
    },"jsonp");
  };
}